import { createMuiTheme } from "@material-ui/core";
import { checkDomainIsCaptis } from "../utils/Index";

const isCaptis = checkDomainIsCaptis();
const theme = createMuiTheme({
  palette: {
    primary: {
      main: isCaptis ? "#3170EB" : "#8a2be2",
      lightMain: isCaptis ? "#a0befa" : "#b39ddb",
    },
  },
});

export default theme;
